export default __webpack_public_path__ + "static/727-b79c83ad870fdd31cf78495b0ca87223.gif";